"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getNumberFormat = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getNumberFormat = function getNumberFormat(value, locale, options) {
  return new Intl.NumberFormat(locale, options).format(value);
};

exports.getNumberFormat = getNumberFormat;

var NumberFormat = function NumberFormat(_ref) {
  var value = _ref.value,
      children = _ref.children,
      locale = _ref.locale,
      options = _ref.options;
  return _react.default.createElement("span", null, getNumberFormat(value || children, locale, options));
};

NumberFormat.propTypes = {
  /** Value to format. Preferred over children. Either value or children is required */
  value: _propTypes.default.any,

  /** Value to format. Either value or children is required */
  children: _propTypes.default.any,

  /** Locale to use in formatting */
  locale: _propTypes.default.string,

  /** Options passed to number formatter */
  options: _propTypes.default.object
};
NumberFormat.defaultProps = {
  value: '',
  children: '',
  locale: 'nb',
  options: {}
};
var _default = NumberFormat;
exports.default = _default;